"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCreator = void 0;
var analytics_layer_1 = require("@pmi/analytics-layer");
var cartView_1 = require("./cartView");
var checkoutConfirmation_1 = require("./checkoutConfirmation");
var checkoutPayment_1 = require("./checkoutPayment");
var checkoutReview_1 = require("./checkoutReview");
var checkoutStep1_1 = require("./checkoutStep1");
var searchLoad_1 = require("./searchLoad");
var quoteLoad_1 = require("./quoteLoad");
var quoteConfirmationLoad_1 = require("./quoteConfirmationLoad");
var configViewLoad_1 = require("./configViewLoad");
var contentViewLoad_1 = require("./contentViewLoad");
var productViewLoad_1 = require("./productViewLoad");
var freeProductViewLoad_1 = require("./freeProductViewLoad");
var freeAccessSucceesLoad_1 = require("./freeAccessSucceesLoad");
var certAppLoad_1 = require("./certAppLoad");
var creatorMappings = (_a = {},
    _a[analytics_layer_1.PageLoadEventNames.CartViewLoad] = cartView_1.cartViewCreator,
    _a[analytics_layer_1.PageLoadEventNames.SearchLoad] = searchLoad_1.searchLoadCreator,
    _a[analytics_layer_1.PageLoadEventNames.CheckoutConfirmation] = checkoutConfirmation_1.checkoutConfirmationCreator,
    _a[analytics_layer_1.PageLoadEventNames.CheckoutPaymentLoad] = checkoutPayment_1.checkoutPaymentCreator,
    _a[analytics_layer_1.PageLoadEventNames.CheckoutReviewLoad] = checkoutReview_1.checkoutReviewCreator,
    _a[analytics_layer_1.PageLoadEventNames.CheckoutStep1Load] = checkoutStep1_1.checkoutStep1Creator,
    _a[analytics_layer_1.PageLoadEventNames.QuoteLoad] = quoteLoad_1.quoteLoadCreator,
    _a[analytics_layer_1.PageLoadEventNames.QuoteConfirmationLoad] = quoteConfirmationLoad_1.quoteConfirmationLoadCreator,
    _a[analytics_layer_1.PageLoadEventNames.ConfViewLoad] = configViewLoad_1.confViewLoadCreator,
    _a[analytics_layer_1.PageLoadEventNames.ContentViewLoad] = contentViewLoad_1.contViewLoadCreator,
    _a[analytics_layer_1.PageLoadEventNames.ProductViewLoad] = productViewLoad_1.prodViewLoadCreator,
    _a[analytics_layer_1.PageLoadEventNames.FreeProductViewLoad] = freeProductViewLoad_1.freeProdViewLoadCreator,
    _a[analytics_layer_1.PageLoadEventNames.FreeAccessSuccess] = freeAccessSucceesLoad_1.freeAccessSuccessLoadCreator,
    _a[analytics_layer_1.PageLoadEventNames.CertAppLoad] = certAppLoad_1.certLoadCreator,
    _a);
var getCreator = function (eventName) { return creatorMappings[eventName]; };
exports.getCreator = getCreator;
